import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-training-videos',
  templateUrl: './training-videos.component.html'
})
export class TrainingVideosComponent {
  
  videos = [
    { 
      title: 'Basics of Insurance', 
      link: 'https://techsurance-assets.s3.ap-south-1.amazonaws.com/19-10-2026/Basics+Of+Insurance.mp4' 
    },
    { 
      title: 'Introduction of Life Insurance', 
      link: 'https://techsurance-assets.s3.ap-south-1.amazonaws.com/19-10-2026/Introduction+Of+Life+Insurance.mp4' 
    },
    { 
      title: 'Prospects of Indian Life Insurance Industry', 
      link: 'https://techsurance-assets.s3.ap-south-1.amazonaws.com/19-10-2026/Prospects+Of+Indian+Life+Insurance+Industry.mp4' 
    },
    { 
      title: 'Methods of Underwriting', 
      link: 'https://techsurance-assets.s3.ap-south-1.amazonaws.com/19-10-2026/Methods+Of+Underwriting.mp4' 
    },
    { 
      title: 'Underwriting Profile', 
      link: 'https://techsurance-assets.s3.ap-south-1.amazonaws.com/19-10-2026/Underwriting+Profile.mp4' 
    }
  ];

  constructor(private router: Router) {}

  openVideo(video: any): void {
    // Redirect to the watch route, passing the title and link as query parameters
    this.router.navigate(['/techsure/watch'], {
      queryParams: { title: video.title, link: video.link }
    });
  }
}